import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { EMPTY, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import type { CompletionResponseDto } from '@/api';
import { QuestionnaireCompletionsService } from '@/api';
import { SnackbarService } from '@/services/snackbar/snackbar.service';

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- RouterStateSnapshot требуется интерфейсом ResolveFn
export const completionByIdResolver: ResolveFn<CompletionResponseDto | null> = (route, _state) => {
  const router = inject(Router);
  const snackbar = inject(SnackbarService);
  const api = inject(QuestionnaireCompletionsService);

  const navigateOnError = (): void => {
    const userId = route.paramMap.get('userId');
    if (userId) {
      router.navigate(['/users', userId, 'history']);
    } else {
      router.navigate(['/history']);
    }
  };

  const id = Number(route.paramMap.get('completionId'));
  if (!Number.isInteger(id) || id < 1) {
    snackbar.error('Прохождение не найдено');
    navigateOnError();
    return EMPTY;
  }

  const routeUserId = route.paramMap.get('userId');

  return api.getCompletionById(id).pipe(
    switchMap((completion) => {
      if (routeUserId && completion.userId !== Number(routeUserId)) {
        snackbar.error('Прохождение не найдено');
        navigateOnError();
        return EMPTY;
      }
      return of(completion);
    }),
    catchError(() => {
      snackbar.error('Прохождение не найдено');
      navigateOnError();
      return EMPTY;
    }),
  );
};
